module.exports = __webpack_public_path__ + "img/ivTest_sub68.be953eb1.jpg";